// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { dispatchSkyfireMethods, globals } from '../utils';
import { sendFeedback } from '../utils/sendHeartbeatFeedback';
import * as Styles from './FeedbackDialog.scss';
const { window } = globals;
export default function FeedbackDialog(props) {
    useStyles(Styles);
    const dispatch = useDispatch();
    const { header, cancelButtonText, submitButtonText, closeDialogOnItemSelected, bodyContent1, bodyHeader1, bodyContent2, bodyHeader2, faqText, customerServiceText, faqUrl, customerServiceUrl, textInputPlaceholder, operatingSystem, browser } = props.template;
    const [feedback, setFeedback] = useState('');
    // Add backbutton & escape button event listeners.
    useEffect(() => {
        window.addEventListener('keydown', handleEscape);
        window.addEventListener('popstate', handleBack);
        return () => {
            window.removeEventListener('keydown', handleEscape);
            window.removeEventListener('popstate', handleBack);
        };
    }, []);
    const handleTextChange = (e) => setFeedback(e.target.value);
    return (React.createElement("div", { className: Styles.modal, role: "dialog", "aria-modal": "true", "aria-labelledby": "dialogHeader", "aria-describedby": "dialogBodyText", id: "dialog" },
        React.createElement("div", { className: Styles.modalContent },
            renderCloseButton(),
            React.createElement("div", { className: Styles.messageContainer },
                React.createElement("h1", { className: 'music-headline-3 ' + Styles.dialogTitle, id: "dialogHeader" }, header),
                React.createElement("div", { className: Styles.textSection },
                    React.createElement("h1", { className: "music-headline-4" }, bodyHeader1),
                    React.createElement("p", { className: "music-primary-text", id: "dialogBodyText" }, bodyContent1),
                    React.createElement("ul", { className: Styles.linkList },
                        React.createElement("li", null,
                            React.createElement("a", { href: faqUrl, target: "_blank", rel: "noopener" }, faqText)),
                        React.createElement("li", null,
                            React.createElement("a", { href: customerServiceUrl, target: "_blank", rel: "noopener" }, customerServiceText)))),
                React.createElement("div", { className: Styles.textSection },
                    React.createElement("h1", { className: "music-headline-4" }, bodyHeader2),
                    React.createElement("p", { className: "music-primary-text" }, bodyContent2)),
                React.createElement("textarea", { autoFocus: true, onChange: handleTextChange, value: feedback, placeholder: textInputPlaceholder })),
            React.createElement("div", { className: Styles.buttonContainer },
                React.createElement("music-button", { role: "button", variant: "glass", size: "small", onClick: handleSelected }, cancelButtonText),
                React.createElement("music-button", { role: "button", variant: "solid", disabled: !feedback, size: "small", onClick: submit }, submitButtonText)))));
    function renderCloseButton() {
        return (React.createElement("div", { className: Styles.closeButtonContainer, id: "dialogCloseButton" },
            React.createElement("music-button", { role: "button", variant: "glass", size: "small", "icon-only": true, "icon-name": 'cancel', onClick: handleSelected })));
    }
    async function submit() {
        if (!feedback) {
            return;
        }
        await sendFeedback(feedback, operatingSystem, browser);
        handleSelected();
    }
    function handleSelected(e) {
        var _a;
        (_a = e) === null || _a === void 0 ? void 0 : _a.preventDefault();
        dispatchSkyfireMethods(dispatch, props.template, closeDialogOnItemSelected);
    }
    function handleEscape(e) {
        if (e.keyCode === 27) {
            handleSelected(e);
        }
    }
    ;
    function handleBack(e) {
        handleSelected(e);
        e.preventDefault();
        // Since we can't actually cancel this event, we put the URL back to what it was
        // before anyone notices it has changed
        history.go(1);
    }
    ;
}
